import script from "./WhiteboardToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteboardToolbar.vue?vue&type=script&setup=true&lang=js"

import "./WhiteboardToolbar.vue?vue&type=style&index=0&id=3e1697ee&lang=css"

const __exports__ = script;

export default __exports__